'use client';
import type { EmitActionParams } from '@unifyapps/defs/hooks/useBlockAction';
import type { ActionContextPayload } from '@unifyapps/defs/hooks/useBlockEvents';
import { createContext, useContext } from 'react';

export type OnActionArgs = Omit<EmitActionParams, 'actionContext'> & {
  actionContext: ActionContextPayload;
};

export type OnActionType = (args: OnActionArgs) => Promise<boolean>;
export type ActionHandlerType = OnActionType;
export const ActionsProviderContext = createContext<{
  doAction?: OnActionType;
}>({});

export const useActionsContext = () => {
  const context = useContext(ActionsProviderContext);
  return context;
};
